import { useState } from 'react';
import { RenderBitsIcon } from 'src/App/Components/ImagesRender/RenderBitsIcon';
import { OverlayHfx } from 'src/App/Components/Overlay/OverlayHfx';
import { hfxGetUrl } from 'src/App/Helpers/hfxGetUrl';
import { ICommand } from 'src/App/Types/command.types';
import { CommandItemContain, CITopSection, CIName, CIBottomBar } from '../CommandItem/CommandItem.styles';
import { CIBitsNumberWrapper, CIGifWrapper } from './HfxItem.styles';

export function HfxItem({ triggerCommand, command }: { triggerCommand: (command: ICommand) => Promise<boolean>; command: ICommand }) {
	const [overlayOpen, setOverlayOpen] = useState(false);
	const [preview] = useState(hfxGetUrl(command, true));

	//handle Opening overlay
	function handleModalOpen() {
		setOverlayOpen(true);
	}
	function handleModalClose() {
		setOverlayOpen(false);
	}

	return (
		<>
			{overlayOpen && <OverlayHfx triggerCommand={triggerCommand} close={handleModalClose} command={command} showImage />}
			<CommandItemContain onClick={handleModalOpen}>
				<CITopSection>
					<div>
						<CIName>{command.name}</CIName>
					</div>
				</CITopSection>
				<CIBottomBar>
					<CIGifWrapper>
						<img loading="lazy" src={preview} alt={command.hfx} />
					</CIGifWrapper>
					{command.bits > 0 ? (
						<CIBitsNumberWrapper>
							<RenderBitsIcon bits={command.bits} />
							{command.bits} Bits
						</CIBitsNumberWrapper>
					) : (
						<CIBitsNumberWrapper>Free</CIBitsNumberWrapper>
					)}
				</CIBottomBar>
			</CommandItemContain>
		</>
	);
}
